<template>
<div>
  <el-dialog :title="row.title" :visible.sync="row.dialogFormVisible"  :width=" row.url.stauts ==='查看'|| row.url.stauts ==='编辑'||row.url.stauts==='添加'?'35%': '300px'" center >
<div class="check_watch">
<el-form :model="row.form" :rules="rules" ref="ruleForm" label-position="right" label-width="80px"  class="demo-ruleForm" :disabled='row.url.stauts==="查看"' v-if="row.url.stauts==='查看'|| row.url.stauts==='编辑'||row.url.stauts==='添加'">
  <el-form-item label="词语展示" prop="词语展示">
     <el-tooltip popper-class="atooltip" effect="dark" content="如果希望录音识别更准确,可以录入更多同音词用,号隔开,小程序展示第一个" placement="right">
      <el-input v-model="row.form.词语展示" maxlength="14" ></el-input>
    </el-tooltip>
  
  </el-form-item>
  <!-- <el-form-item
                    v-for="(let, index) in row.form.词语名称"
                    :label="'词语名称'+index"
                    :key="index"
                    :prop="'词语名称['+index+']'"
                    maxlength="60"
                    :rules="[
                {  required: true,  message: '请输入', trigger: 'blur' }
            ]"
                >
                <div class="domain">
                     <el-input v-model="let"></el-input>
                    <el-button v-if="row.句子.length <= 1?false:true" @click.prevent="removeDomain(domain)" type="info" icon="el-icon-delete" circle></el-button>
                     <el-button @click="addDomain" v-if="row.句子.length-1 === index?true:false" type="info" icon="el-icon-plus"  circle=""></el-button>

                </div>
                   
    </el-form-item> -->
   <el-form-item label="拼音" prop="拼音">
     <div class="spell">
       <el-radio-group v-model="row.form.拼音">
       </el-radio-group>
      <el-input v-model="row.form.拼音"   class="spell_input"></el-input>
       <el-tooltip popper-class="atooltip" effect="dark" content="在每个字的拼音之间需要加空格" placement="right">
       <el-button  type="primary" @click="watchword" class="spell_buttom">转换</el-button>
    </el-tooltip>
   
     </div>
  </el-form-item>
  <el-form-item label="星级"  prop="star">
    <el-select v-model="row.form.star" placeholder="" :disabled='row.url.stauts==="查看"' class="select">
      <el-option :label="options[row.form.star].laeb" :value='options[row.form.star].value' disabled></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="音频文件" >
        <el-upload
              class="upload-demo"
              ref="customUpload"
              :action="target+'file/upload'"
              :data="tokenchange"
             :before-upload="handleBeforeUpload"
             :on-success="handsuccess"
             :on-change="upl"
              multiple
              accept='.mp3,.m4a,*.cda,.wav,.aac,.wma,.ogg,.flac,.ape,.wav,.amr,.3gpp,.he-aac'
              :limit="1"
              :auto-upload="false"
              >
        <el-button size="small" type="primary" >点击上传</el-button>
        <p v-if="show">{{row.form.文件 === undefined?'':row.form.文件[0].name }}</p>
</el-upload>
  </el-form-item>
</el-form>
<p v-if="row.url.stauts==='删除'" class="delete">是否确认删除？</p>

</div>
 <span slot="footer" class="dialog-footer dialog_buttom">
  <el-button @click="row.dialogFormVisible=false" class="buttom_one">{{buttom.clock}}</el-button>
   <el-button type="primary" @click="submitForm('ruleForm',row.url.stauts)">{{buttom.chage}}</el-button>
</span>
</el-dialog>

</div>
</template>
<script>
  import {mapState,mapMutations,mapActions} from 'vuex'
  import upload from '@/api/upload.js'
  import testServer from '@/api/management.js'
import { request } from 'https';
let pinyin = require("pinyin");
 const naimeng =(params) =>{
    let index = params.indexOf(',')
   
    if (index === -1) {
        return params
    } else{
        return params = params.substring(0,index)
    }
    
}
export default {
    name:'li-dialog',
    props: ['dialog'],
    inject:['reload'],
    data() {
      return {
        file:'',
        row:'',
        show:true,
        spell:null,
        filestatus:true,
        target:'',
        pinstatus:false,
        page:'',
        pin:'',
        buttom:{
          clock:'取消',
          chage:'确定'
        },
        change:'',
         options:[
          {laeb:'零星级',value:0},
          {laeb: '一星级',value:1},
          {laeb: '二星级',value:2},
          {laeb: '三星级',value:3},
          {laeb: '四星级',value:4},
          {laeb: '五星级',value:5},
          {laeb: '六星级',value:6},
          {laeb: '七星级',value:7},
          {laeb: '八星级',value:8},
          {laeb: '九星级',value:9},
          {laeb: '十星级',value:10},
          
         ],
        rules: {
          词语展示: [
           
            {  required: true,  message: '请输入', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1到 20 个字符',  trigger: 'blur' },
          ],
          拼音:[
            {  required: true,  message: '请转换', trigger: 'blur' }
          ],
          star: [
            { required: true,  message: '请选择星级', trigger: 'change' }
          ]
        
        },
        
      };
    },
   computed: {
    tokenchange(){
      return {
        token: JSON.parse(sessionStorage.getItem('token')).token
        }
    },
     
      ...mapState('managlist', ['wordList'])
    },
    updated () {
    
    
    },
    mounted () {
      let proEnv = require('../../config/pro.env');  // 生产环境
const env = process.env.NODE_ENV;
let target = '';
if(env==='production'){  // 生产环境
  target = proEnv.hosturl+'/';
}else{  // 本地环境
  target = '/'
}
this.target =target
      this.row  = this.dialog
      console.log(target)
      console.log(this.row)
      // switch (url.status) {
      //   case '查看':
          
      //     break;
      
      //   default:
      //     break;
      // }
     
    },
    methods: {
    ...mapActions('managlist', ['FETCH_WORD_SAVE','FETCH_WORD_LIST','FETCH_ARTICLE_LIST']),
    ...mapMutations('managlist',['test_List']),
    upl(file,filelist){
        console.log('ada',file)
        this.show =false 
        this.filestatus = false
        console.log(filelist)
    },
   
   watchword(){
      // this.row.form.拼音 = ''
    this.pinstatus = true
    let spell =   pinyin(naimeng(this.wordChange(this.row.form.词语展示)))
    let newSpell =''
     for (let index = 0; index < spell.length; index++) {
      spell[index].forEach(item => {
        newSpell= newSpell+ item+' '
      });
    }
    this.$set( this.row.form,'拼音',newSpell.replace(/ $/gi,""))
    // this.spell = newSpell.replace(/ $/gi,"");
    
    // Object.values(spell).reduce((a,b) => [...a, ...b], [])
    // spell.reduce((acc, cur)=>acc.concat(cur))
    console.log( this.row.form.拼音)
   console.log(newSpell)
   this.pinstatus = false
    },
    wordChange(word){
       if(word.indexOf("，") != -1)
    {
    return  word.replace(/，/g, ',');
    }else{
     return word  
    }
    },
  async  handsuccess(response,file,fileList){
      this.fileSuseese  = response.status
      console.log(file,fileList)
      fileList = []
      console.log('删除了',fileList)
     if(response.status === 0){
        this.change = {
               id:this.row.form.id,
               checkpointId : this.row.form.checkpointId,
               name:this.wordChange(this.row.form.词语展示),
               spell:this.row.form.拼音,
               star:this.row.form.star,
               audio: response.data,
              
           }
          if (this.row.url.stauts ==='添加') {
          this.row.form.文件 = undefined
      }
        await  this.FETCH_WORD_SAVE(this.change)
        let commit = {
          id:this.row.form.checkpointId,
          page:this.row.page,
          pageSize:this.row.pageSize
        }
         this.FETCH_WORD_LIST(commit)
         this.$refs.customUpload.clearFiles()
        this.row.dialogFormVisible = false
         this.show = true
     }
  
    },
  async  qing(change){
             await  this.FETCH_WORD_SAVE(change)
                this.row.dialogFormVisible = false
                 this.show =true 
                 this.FETCH_WORD_LIST({id:this.row.form.checkpointId, page:this.row.pagea })
               
    },
    handleBeforeUpload(file){
    // this.file = new window.FormData();
    //   this.file.append('file', file)
      console.log(file)
     
    },
    async submitForm(ruleForm,status) {
      
       console.log('路由啊啊杜萨的啊打', this.row.form.拼音)
         switch (status) {
                case '查看':
                  this.row.dialogFormVisible= false
                  console.log('ccccc')
             console.log(this.wordList)
                    break;
            
                case '编辑':
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
             this.$refs.customUpload.submit();
            if(this.change ===''){
                 const change = {
               id:this.row.form.id,
               checkpointId : this.row.form.checkpointId,
               'name':this.wordChange(this.row.form.词语展示),
               'spell':this.row.form.拼音,
               'star':this.row.form.star,
                audio: this.row.form.文件[0].name,
               
              
           }
             this.qing(change)
             
            } else{

                this.qing(this.change)
            }
          
          } else {
            console.log('error submit!!');
            return false;
          }
        });
          
                    break;
                case '添加':
                   this.$forceUpdate();
                  console.log(this.row.form.拼音)
                  console.log(  this.$refs[ruleForm])
        //  this.row.form.拼音 = this.spell
         this.$refs[ruleForm].validate((valid) => {
          if (valid) {
              console.log('zoujinql')
              if(this.filestatus === false){
                       this.$refs.customUpload.submit();
                      this.filestatus = true
              } else {
                  const h = this.$createElement;
        this.$notify({
          message: h('i', { style: 'color: #000'}, '请上传文件')
        });
              }
        
          } else if (this.row.form.拼音){
   this.$refs.customUpload.submit();
                      this.filestatus = true            
          } 
          else {
            console.log('error submit!!');
            return false;
          }
        });
           
             
                break;
                case '删除':
               
                 console.log(  this.row.pagea )
                  if(this.$route.path === '/词库查看'){
                      
                  await testServer.word.delete({id:this.row.form.id})
                     this.row.dialogFormVisible = false  
                  this.FETCH_WORD_LIST({id:this.row.form.queryid,page:this.row.pagea })
               
                  } else {
                    
                  await testServer.article.delete({id:this.row.form.id})
                  this.row.dialogFormVisible = false 
                   this.FETCH_ARTICLE_LIST({star:this.row.form.gostar,page:this.row.pagea })
                    
                  }
              

            }
            // eslint-disable-next-line no-console
           // eslint-disable-next-line no-console
           
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
           
        //     alert('submit!');
        //   } else {
        //     // eslint-disable-next-line no-console
        //     console.log('error submit!!');
        //     return false;
        //   }
        // });
        
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style lang="scss" scoped>

.check_watch{
  //  text-align: center;
    margin: 0 auto;
    padding: 0 10%;
    .demo-ruleForm{
      .item_tooltip{
       background: #ee3f4d
      }
      .spell{
        display: flex;
        align-items: center;
        .spell_input{
          width: 80%;
        }
       .spell_buttom{
         margin-left: 15px;
       }
      }
    }
    .select{
      width: 100%;
    }
    .delete{
      margin:  0% 0;
      font-size: 15px;
    }
    .dialog_buttom{
      width: 100%;
      display: flex;
      // justify-content: center;
      .buttom_one{
        flex: 1;
      }
    }
}
</style>
